module.exports = __webpack_public_path__ + "media/bootstrap-icons/stars-7c6d945c.svg";